import { request } from "./core";

export type BillingPlan = "developer" | "team" | "business";

export interface CreateCheckoutResponse {
    checkout_url: string;
}

export function createCheckout(
    orgId: string, plan: BillingPlan,
): Promise<CreateCheckoutResponse> {
    return request(`/orgs/${orgId}/billing/create-checkout`, {
        method: "POST",
        body: JSON.stringify({ plan }),
    });
}

export type SubscriptionGateState =
    | "healthy"
    | "grace"
    | "blocked"
    | "unknown";

export interface SubscriptionResponse {
    org_id: string;
    plan: string;
    status: string;
    billing_provider?: "stripe" | "paddle";
    pending_checkout?: boolean;
    current_period_end: string | null;
    cancel_at_period_end?: boolean;
    monthly_tool_calls: number;
    usage_period_start: string;
    limit_servers: number | null;
    limit_monthly_tool_calls: number | null;
    gate_state: SubscriptionGateState;
}

export function getSubscription(orgId: string): Promise<SubscriptionResponse> {
    return request(`/orgs/${orgId}/subscription`);
}

export interface PortalResponse {
    portal_url: string;
}

export function getBillingPortal(orgId: string): Promise<PortalResponse> {
    return request(`/orgs/${orgId}/billing/portal`, { method: "POST" });
}

export interface BillingInvoiceLine {
    id: string;
    number: string | null;
    amount_due: number;
    amount_paid: number;
    currency: string;
    status: string;
    created_at: string;
    period_start: string | null;
    period_end: string | null;
    hosted_invoice_url: string | null;
    invoice_pdf: string | null;
}

export interface BillingSummaryResponse {
    subscription: SubscriptionResponse;
    current_server_count: number;
    over_limit_servers: number;
    recent_invoices: BillingInvoiceLine[];
}

export function getBillingSummary(orgId: string): Promise<BillingSummaryResponse> {
    return request(`/orgs/${orgId}/billing/summary`);
}
